<div class="sessions" *ngIf="sessionCounter && data">

    <bos-static-table [data]="data" [translatePrefix]="'Session.'"
                      [displayedColumns]="displayedColumns">
    </bos-static-table>


</div>
